<template>
  <section class="account-dashboard content">
    <AccountTabs v-model="activeTab" :tabs="tabs">
      <template #default="{ activeTab }">
        <Overview v-show="activeTab === 'Overview'" />
        <Breakdown v-show="activeTab === 'Account Breakdown'" />
      </template>
    </AccountTabs>
  </section>
</template>
<script>
import AccountTabs from '@/components/dashboard/AccountTabs.vue'
import Overview from '@/components/dashboard/usage/Overview.vue'
import Breakdown from '@/components/dashboard/usage/Breakdown.vue'

export default {
    components: {
        AccountTabs,
        Overview,
        Breakdown
    },
    data() {
        return {
            tabs: ['Overview', 'Account Breakdown'],
            activeTab: 'Overview'
        }
    },
}
</script>
<style lang="scss" scoped>
.account-dashboard {
  &.content {
    padding: 24px;
  }
}
</style>
